import React, { useState } from "react";
import { Icon, Input, Select, Button as ButtonS } from "semantic-ui-react";
import { Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import { useHistory } from "react-router-dom";
import { deleteBerita, getBerita, getBeritaPublish, getBeritaDraft } from "../../api/beritaApi";
import { ModalFooter } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import moment from "moment";
import LoadingTop from "../../component/LoadingTop";

const Berita = () => {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [beritaId, setBeritaId] = useState(null);
  const [status, setStatus] = useState(2);
  const [search, setSearch] = useState("");

  const parsedDateInd = (cell, row) => {
    return cell ? moment.utc(cell).locale("id").tz("Asia/Jakarta").format("DD MMMM YYYY HH:mm") : "-";
  };

  const showStatus = (s) => {
    return s === 1 ? (
      <span className="badge badge-success">Publish</span>
    ) : (
      <span className="badge badge-secondary">Draft</span>
    );
  };

  const handleAction = (d, type) => {
    if (type === "edit") return history.push(`/berita/edit?id=${d.id}`);
    else return openModal(d.id);
  };

  const formatterAction = (cell, row) => {
    return (
      <>
        <Icon name="pencil" className="cursor-pointer" onClick={() => handleAction(row, "edit")} />
        <Icon name="trash alternate outline" color="red" className="cursor-pointer" onClick={() => handleAction(row, "delete")} />
      </>
    );
  };

  const columns = [
    {
      dataField: "title",
      text: "Judul",
    },
    {
      dataField: "status",
      text: "Status",
      formatter: showStatus,
    },
    {
      dataField: "updatedAt",
      text: "Terakhir Diperbarui",
      formatter: parsedDateInd,
    },
    {
      dataField: "createdBy.email",
      text: "Oleh",
    },
    {
      dataField: "perusahaan.nama",
      text: "Perusahaan",
    },
    {
      text: "",
      formatter: formatterAction,
      headerStyle: () => ({ width: "10%" }),
    },
  ];

  const toggle = () => setModal(!modal);

  const loadData = async (s, q) => {
    try {
      let res;
      if (s === 1) res = await getBeritaPublish();
      else if (s === 0) res = await getBeritaDraft();
      else res = await getBerita(q);
      setData(res.data.content);
    } catch (err) { }
  };

  const openModal = (id) => {
    setModal(true);
    setBeritaId(id);
  };

  const filter = (e, { value }) => {
    setStatus(value);
    loadData(value);
  };

  const indication = () => {
    return <p className="text-center">{data ? "Belum ada data" : "Loading data ..."}</p>;
  };

  const handleDelete = async () => {
    setLoadingDelete(true);
    try {
      await deleteBerita(beritaId);
      toggle();
      setBeritaId(null);
      await loadData();
    } catch (err) { }
    setLoadingDelete(false);
  };

  const handleSearch = async (e, { value }) => {
    setSearch(value);
    loadData(null, value);
  };

  React.useEffect(() => {
    loadData();
  }, []);

  return (
    <>
      <LoadingTop />
      <div className="card border-0 rounded-0">
        <div className="container py-4 px-5">
          <div className="row">
            <div className="col-md-6 d-flex align-items-center mb-md-0 mb-3">
              <h3>Berita</h3>
            </div>
            <div className="col-md-6 d-flex justify-content-end">
              <ButtonS color="blue" onClick={() => history.push("/berita/add")}>
                + &nbsp; Tambah
              </ButtonS>
            </div>
          </div>
        </div>
      </div>
      <div className="container mt-3">
        <div className="row">
          <div className="col-md-12">
            <div className="card container shadow-sm py-3 border-0">
              <div className="row">
                <div className="col-md-6 d-flex align-items-center">
                  <Input icon iconPosition="left" className="w-100 my-3" placeholder="Cari Berita" onChange={handleSearch}>
                    <input />
                    <Icon name="search" />
                  </Input>
                </div>
                <div className="col-md-4 d-flex justify-content-start align-items-center">
                  <Select
                    className={`input--perusahaan`}
                    options={[
                      { value: 2, text: "Semua" },
                      { value: 0, text: "Draft" },
                      { value: 1, text: "Published" },
                    ]}
                    value={status}
                    onChange={filter}
                    placeholder="Pilih Status"
                  />
                </div>
              </div>
              <BootstrapTable
                headerClasses="table--header"
                keyField="id"
                data={data || []}
                columns={columns}
                // bordered={false}
                noDataIndication={indication}
              // hover={props.hover}
              // rowEvents={props.rowOnClick && rowEvents}
              // ddefaultSortDirection="asc"
              // rowStyle={ rowStyle }
              />
            </div>
          </div>
        </div>
      </div>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Konfirmasi</ModalHeader>
        <ModalBody>Apakah anda yakin akan menghapus data?</ModalBody>
        <ModalFooter>
          <ButtonS color="light" onClick={toggle}>
            Tidak
          </ButtonS>
          <ButtonS color="red" onClick={handleDelete} loading={loadingDelete}>
            Ya
          </ButtonS>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Berita;
